export default {
	methods: {
		registerWebComponent() {
			const [_, name] = this.nodeInfo.type.split('-')
			const tag = name.replace(/([A-Z])/g, '-$1').toLowerCase()
			const oldDom = this.$refs[this.nodeInfo.id]
			const newDom = document.createElement(tag)
			this.appendStyle(newDom)
			this.setAttribute(newDom)
			this.setProps(newDom)
			this.mixinContext(newDom)
			this.injectBridge(newDom)
			oldDom.replaceWith(newDom)
			this.registerEvent(newDom)
		},
		setAttribute(dom) {
			dom.setAttribute('data-node-id', this.nodeInfo.id)
			dom.setAttribute('data-node-type', this.nodeInfo.type)
			dom.setAttribute('data-node-version', this.nodeInfo.version)
		},
		setProps(dom) {
			const props = this.nodeInfo.props
			Object.keys(props).forEach(key => {
				dom[key] = props[key]
			})
		},
		registerEvent(dom) {
			const { events } = this.nodeInfo
			if (!Array.isArray(events)) return
			if (!events.length) return
			events.forEach(event => {
				const { name, listeners } = event
				dom.addEventListener(name, data => {
					listeners.forEach(listener => {
						try {
							const { actionName, nodeId } = listener
							let targetDom = this.getComponent(listener.nodeId, true)
							if (targetDom) {
								if (!targetDom._isVue) {
									targetDom = document.querySelector(`[data-node-id="${nodeId}"]`)
								}
								targetDom[actionName] && targetDom[actionName](data.detail[0])
							} else {
								window.app.$on(`$doLoadNode-${nodeId}`, onComponent => {
									if (!onComponent._isVue) {
										onComponent = document.querySelector(`[data-node-id="${nodeId}"]`)
									}
									onComponent[actionName] && onComponent[actionName](data.detail[0])
								})
							}
						} catch (error) {
							console.error('webcomponent-events-on', event.name, error)
						}
					})
				})
			})
		},
		getComponent(id, child) {
			const component = window.$_nodePrecomponents[id]
			if (child && component) {
				return component.$refs[id]
			}
			return component
		},
		mixinContext(dom) {
			const scripts = this.mixinsScript()
			dom._def && (dom._def.mixins = scripts)
		},
		injectBridge(dom) {
			const allBridge = this.apiAspect(window.AllBridge, ['setDebug', 'setConsoleLogLevel'])
			const allUI = this.apiAspect(this.$UI, [])
			const allService = {
				resource: this.apiAspect(this.$Service.resource, []),
				award: this.apiAspect(this.$Service.award, []),
			}
			dom.allBridge = allBridge
			dom.allUI = allUI
			dom.allService = allService
		},
		async appendStyle(dom) {
			if (this.nodeInfo.shadowStyle) {
				const shadowStyleSheet = document.createElement('style')
				shadowStyleSheet.innerHTML = this.nodeInfo.shadowStyle
				dom.shadowRoot.append(shadowStyleSheet)
			}
			if (this.nodeInfo.externalCssUrl) {
				try {
					const extraCssSheet = document.createElement('link')
					extraCssSheet.href = this.nodeInfo.externalCssUrl
					extraCssSheet.rel = 'stylesheet'
					dom.shadowRoot.append(extraCssSheet)

					const cssId = `external-css-${btoa(this.nodeInfo.externalCssUrl).replace(/[+/=]/g, '')}`
					if (document.getElementById(cssId)) {
						return
					}
					const extraCssSheetHead = document.createElement('link')
					extraCssSheetHead.id = cssId
					extraCssSheetHead.href = this.nodeInfo.externalCssUrl
					extraCssSheetHead.rel = 'stylesheet'
					document.head.append(extraCssSheetHead)
				} catch (err) {
					console.log('load extra css failed', err)
				}
			}
		},
	},
}
